import React from 'react';
import { Checkbox } from 'evergreen-ui';
import useMapEnableClustering from './useMapEnableClustering';

export default function MapViewEnableClusteringCheckbox() {
  const { isEnableClustering, toggle } = useMapEnableClustering();

  const onChange = () => toggle();

  return (
    <Checkbox
      label="Включить кластеризацию"
      checked={isEnableClustering}
      onChange={onChange}
    />
  );
}
